import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.251 7.395a.86.86 0 0 0 0 1.213l5.141 5.141a.858.858 0 0 0 1.213-1.213L6.07 8l4.533-4.536A.858.858 0 0 0 9.39 2.251L4.25 7.392z"
    }, null, -1)
  ]))]))
}
export default { render: render }